import React from "react";
import Style from "./SimpleLayout.scss";

interface SimpleLayoutProps {
  children?: React.ReactNode;
}

const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children }) => {
    return (
        <div className={Style.Container}>
            <div className={Style.ContentWrapper}>{children}</div>
        </div>
    );
};

export default SimpleLayout;
